"use strict";
/**
 * Shared shapes for "import historical invoices from a Saga XML export"
 * (apps/api/src/invoices-import + apps/web/src/features/facturi/SagaImportModal.tsx).
 *
 * Unlike the clients-import feature, `companyId` is never supplied by the
 * caller — the issuing firm (and its CUI) is read straight out of the XML's
 * own `FurnizorCIF`, both for preview and for commit. Both endpoints accept
 * only the uploaded file.
 */
Object.defineProperty(exports, "__esModule", { value: true });
